import {Component, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule, ModalController} from '@ionic/angular';
import {LanguageService} from '../../services/language.service';
import {SelectLanguageModal} from '../../modals/select-language/select-language.modal';
import {NgIcon, provideIcons} from "@ng-icons/core";
import * as flagIcons from "@ng-icons/flag-icons";


@Component({
  selector: 'core-select-language',
  standalone: true,
  imports: [CommonModule, IonicModule, NgIcon],
  viewProviders: [provideIcons(flagIcons)],
  templateUrl: './select-language.component.html',
  styleUrls: ['./select-language.component.scss']
})
export class SelectLanguageComponent {
  protected languageService = inject(LanguageService);
  private modalCtrl = inject(ModalController);

  async openLanguageModal() {
    const modal = await this.modalCtrl.create({
      component: SelectLanguageModal,
      initialBreakpoint: 1,
      breakpoints: [0, 1]
    });
    await modal.present();
  }

  getCountryCode(langCode: string): string {
    return this.languageService.getCountryCodeForLanguage(langCode);
  }

  getFlagName(langCode: string): string {
    const country = this.getCountryCode(langCode).toLowerCase();
    return 'flag' + country.charAt(0).toUpperCase() + country.slice(1);
  }
}
